import * as Yup from "yup";

export default Yup.object().shape({
    username: Yup.string().required("Please enter a Username"),
    email: Yup.string().required("Please enter an Email")
});